import { render, staticRenderFns } from "./metro-alert-dialog.vue?vue&type=template&id=2dcb49ae&scoped=true"
import script from "./metro-alert-dialog.vue?vue&type=script&lang=js"
export * from "./metro-alert-dialog.vue?vue&type=script&lang=js"
import style0 from "./metro-alert-dialog.vue?vue&type=style&index=0&id=2dcb49ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb49ae",
  null
  
)

export default component.exports